import { Flex, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import React from 'react'
import { useIntl } from 'react-intl'
import {
  FieldGroupBox,
  Rule,
  RuleActions,
  RuleDefaultActions,
  RuleStack,
  Tag,
  useFormStateContext,
} from 'ui'
import {
  MoreForLessBenefit,
  MoreForLessBenefitVariant,
} from '../../../../../../typings'
import { messages } from '../messages'
import styles from '../styles'
import { AdvancedConfig } from './AdvancedConfig'
import { MaxPriceBenefit } from './MaxPriceBenefit'
import { PercentualBenefit } from './PercentualBenefit'

type Props = {
  name: string
  onRemove: () => void
  onEdit: () => void
  onEditAdvancedConfig: () => void
}

const VIEW_COMPONENT: Record<
  MoreForLessBenefitVariant,
  React.FC<{ value: number }>
> = {
  [MoreForLessBenefitVariant.PERCENTUAL]: PercentualBenefit,
  [MoreForLessBenefitVariant.MAX_PRICE_PER_ITEM]: MaxPriceBenefit,
}

export function ViewBenefit(props: Props) {
  const { name, onRemove, onEdit, onEditAdvancedConfig } = props
  const { form } = useFormStateContext()
  const { $t } = useIntl()

  const benefit: MoreForLessBenefit = useWatch({
    form,
    name,
  })

  if (benefit.discount.value === undefined) return

  const ViewComponent = VIEW_COMPONENT[benefit.discount.type]

  return (
    <Flex direction="column" className={styles.filledBox}>
      <Text>
        {$t(messages.benefit.description, {
          tag: (content) => <Tag>{content}</Tag>,
          count: benefit.quantity,
        })}
      </Text>
      <FieldGroupBox name={name} withBorder={false}>
        <RuleStack>
          <Rule onClick={onEdit}>
            <ViewComponent value={benefit.discount.value} />

            <RuleActions>
              <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
            </RuleActions>
          </Rule>
          <AdvancedConfig
            config={benefit.apply}
            onEdit={onEditAdvancedConfig}
            onRemove={onRemove}
          />
        </RuleStack>
      </FieldGroupBox>
    </Flex>
  )
}
